<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Logo Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editLogo">Edit Logo</button>
                </div>
            </div>
            <div class="table-responsive" v-if="logo">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{logo.logoId}}</td>
                    </tr>
                  <tr>
                    <th>Page</th>
                    <td>{{logo.pageName}}</td>
                  </tr>
                    <tr>
                        <th>Site</th>
                        <td>{{logo.siteNameText}}</td>
                    </tr>
                    <tr>
                        <th>Site URL</th>
                        <td>{{logo.linkDestination}}</td>
                    </tr>
                  <tr>
                    <th>Logo URL</th>
                    <td>{{logo.logoUrl}}</td>
                  </tr>
                  <tr>
                    <th>Logo</th>
                    <td><img :src="logo.logoUrl" alt="logo-image" class="table-thumbnail"></td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="logo.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewLogo',
        components: {
            LTable,
        },
        created (){
            console.log('inside view logo')
        this.$store.dispatch('GETSELECTEDLOGO', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedLogo)
            this.logo = this.selectedLogo;
        })
    },
    data () {
        return {
          logo: {}
        }
    },
    methods: {
        editLogo(){
            this.$router.push({ name: 'EditLogo', params: { id: this.logo.logoId}})
        },
    },
    computed: {...mapGetters([
        'selectedLogo'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logos/LogoDetails.vue